
export default function TileAdhesiveFeatures() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Superior Bonding',
      description: 'Advanced polymer-modified formula ensures maximum adhesion to all substrate types.',
    },
    {
      icon: 'ri-drop-line',
      title: 'Water Resistant',
      description: 'Suitable for wet areas including bathrooms, kitchens, and exterior applications.',
    },
    {
      icon: 'ri-time-line',
      title: 'Extended Open Time',
      description: 'Longer working time allows for precise tile placement and adjustments.',
    },
    {
      icon: 'ri-temp-cold-line',
      title: 'Frost Resistant',
      description: 'Elite Pro tier withstands freeze-thaw cycles for outdoor installations.',
    },
    {
      icon: 'ri-tools-line',
      title: 'Easy Application',
      description: 'Smooth consistency and excellent workability for professional results.',
    },
    {
      icon: 'ri-leaf-line',
      title: 'Low VOC',
      description: 'Environmentally friendly formula with minimal odor and emissions.',
    },
  ];

  return (
    <section className="py-12 md:py-20 px-4 md:px-8 bg-white overflow-x-hidden">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-['Montserrat'] font-bold text-2xl md:text-3xl lg:text-4xl text-center mb-4 text-[#1A1A1A]">
          Key Features
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-10 md:mb-16 max-w-3xl mx-auto">
          Professional-grade tile adhesive engineered for superior performance and reliability.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-8">
          {features.map((feature) => (
            <div key={feature.title} className="text-center px-2">
              <div className="w-16 h-16 bg-[#F2C612] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${feature.icon} text-3xl text-[#1A1A1A]`}></i>
              </div>
              <h3 className="font-['Montserrat'] font-bold text-lg md:text-xl mb-3 text-[#1A1A1A]">
                {feature.title}
              </h3>
              <p className="text-sm md:text-base text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
